import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid } from 'planoplan-ui-kit/core/helpers/grid';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { deviceDetected } from 'planoplan-ui-kit/core/device-detected';
import {textSize, Points, common, marginLevel} from '@styles';
import { useTranslations } from '@libs/translations';

export const DescriptionCard = ({ icon, title, text, isBigStyle = false }) => {
  const translation = useTranslations();
  const formattedText = text.replace(/ style=".*?"/ig, '');
  const firstParagraph = `${formattedText.split('</p>')[0]}</p>`;
  const othersParagraph = formattedText.split('</p>').slice(1).join('</p>');
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  },[text]);

  return (
      <Container>
        {icon &&
          <Icon>
            <img src={icon} alt=""/>
          </Icon>
        }

        {!isBigStyle && <>
          <Title>{title}</Title>
          <Text dangerouslySetInnerHTML={{__html: formattedText}}/>
        </>}

        {isBigStyle && <>
          <Text dangerouslySetInnerHTML={{__html: firstParagraph}}/>
          {(othersParagraph && !isOpen) && <Link onClick={() => setIsOpen(true)}>{translation.t('site.galleryProject.more')}</Link>}

          {othersParagraph &&
            <Text dangerouslySetInnerHTML={{__html: othersParagraph}} style={{display: isOpen ? 'block' : 'none'}}/>
          }

        </>}
      </Container>
  )
};

const Container = styled.div`
  padding: 20px;
  background-color: ${Colors.white};
  border-radius: 20px;
  border: 1px solid #FFB540;
  height: 100%;
  
  @media ${Points.laptop} {
      padding: 30px;
  }
`;

const Icon = styled.div`
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  
  img {
    width: 100%;
    height: 100%;
  }
  
  @media ${Points.tablet_landscape} {
    margin-bottom: 15px;
  }
`;

const Title = styled.div`
  ${textSize('list_header')};
  margin-bottom: 10px;
  
  h1 {
    margin: 0;
    padding: 0;
    font-weight: inherit;
    font-size: inherit;
  }
  
  @media ${Points.tablet_landscape} {
    margin-bottom: 15px;
  }
`;

const Text = styled.div`
  color: ${Colors.black};
  
  ol {
    ${Mixins.resetList()};
  }

  ul {
    ${common('listBig')};
    ${marginLevel('both', 'azure')};
  }

  p,
  li {
    ${textSize('p1_long_with_spacing')};
  }
  
  li {
    padding-left: 26px;
    position: relative;
  }

  b {
    font-weight: 500;
  }

  a {
    ${common('a')};
  }
  
  h2,h3,h4 {
    font-weight: 400;
    ${marginLevel('both', 'azure')};
  }
`;

const Link = styled.button`
  ${Mixins.resetButton()};
  ${Mixins.resetLink()};
  ${textSize('p')};
  display: inline-block;
  margin-top: 15px;
  color: ${Colors.main_blue};
`;
